/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemMenuDaypartResult } from '../../models/item-menu-daypart-result';

export interface DaypartsDaypartIdMenusMenuIdItemsItemIdGet$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;

/**
 * Menu ID
 */
  menuId: string;

/**
 * Item (regular and category) ID
 */
  itemId: string;
}

export function daypartsDaypartIdMenusMenuIdItemsItemIdGet(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdMenusMenuIdItemsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemMenuDaypartResult>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdMenusMenuIdItemsItemIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('menuId', params.menuId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & ItemMenuDaypartResult>;
    })
  );
}

daypartsDaypartIdMenusMenuIdItemsItemIdGet.PATH = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';
